import {IconButton} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import {useSnackbar} from "notistack";

export const CloseAction = (color?: string) => {
	const CloseComponent = (snackbarId: string) => {
		const {closeSnackbar} = useSnackbar();

		return(
			<IconButton onClick={() => closeSnackbar(snackbarId)}>
				<ClearIcon sx={{color}} />
			</IconButton>
		)
	};
	return CloseComponent;
}